import { useEffect, useState } from 'react';
import axiosServices from 'utils/axios';

// Guarda a última configuração conhecida (por subdomínio) para o primeiro
// desenho já sair com as cores certas, sem "piscar" padrão -> personalizado.
// Depois a configuração é buscada de novo e atualiza a tela.
const STORAGE_KEY = 'gix_app_settings:' + (typeof window !== 'undefined' ? window.location.host : '');

const readStored = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

const writeStored = (value) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch (e) {
    /* sem storage disponível: segue sem cache */
  }
};

let cachedSettings = readStored();

// Busca as configurações de aparência (cores navbar/sidebar) da org
// atual — usado tanto no Header quanto no Sidebar.
// `_loaded: true` indica que há configuração pronta (do cache ou da resposta).
export default function useAppSettings() {
  const [settings, setSettings] = useState(cachedSettings ? { ...cachedSettings, _loaded: true } : {});

  useEffect(() => {
    let mounted = true;
    axiosServices
      .get('/app_settings')
      .then(({ data }) => {
        const next = { ...(data || {}), _loaded: true };
        cachedSettings = next;
        writeStored(next);
        if (mounted) setSettings(next);
      })
      .catch((err) => {
        console.error('Failed to load app settings', err);
        if (mounted) setSettings((prev) => ({ ...prev, _loaded: true }));
      });
    return () => {
      mounted = false;
    };
  }, []);

  return settings;
}
